import "bootstrap/dist/css/bootstrap.css";
import React, { useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { environment } from "../../environment.version";
import { PageAtom } from "../../State/Page.Atom";
import { ScorecardAtom } from "../../State/Scorecard.Atom";
import { UserAtom, userRegistrationIdState, userRolesState } from "../../State/user.Atom";
import { VerificationCompanyAtom } from "../../State/VerificationCompany.Atom";
import { Sidebar } from "../Common/Nav/Sidebar";
import { TopNavbar } from "../Common/Nav/TopNavbar";
import { isNullOrEmpty } from "../Model/helpers";
import { Footer } from "./Components/Footer/Footer";
import { AccountRoute, AllNotesRoute, ConstantRoutes, EEScorecardRoutes, ClientRoutes, VerificationRoutes, VerificationCompanyRoutes, OFOCodesCategorisationRoute, OrganisationRoute, BBBEEScorecardRoutes, BEEHubRoutes, BEE123RegistrationRoutes } from "./Constants/routes";
import { AuditRole, PlatformPeopleEditRole, PlatformPeopleViewRole, UserAdminRole, ClientRole } from "./Constants/UserRoles";
import { DashboardLayout } from "./Container/DashboardLayout";
import { ExternalRedirect } from "./externalRedirect";
import { IndividualImport } from "../../Modules/CentralDataManagement/Imports/IndividualImport/IndividualImport";
import { IndividualSalariesImport } from "../../Modules/CentralDataManagement/Imports/IndividualSalaryImports/IndividualSalariesImport";
import { WSPScorecardAtom } from "../../State/WSPScorecard.Atom";
import { OrganisationAtom } from "../../State/Organisation.Atom";
import { CreateOrganisationPerson } from "../../Modules/Organisations/PeopleAndTraining/Person/CreatePerson/CreateOrganisationPerson";
import { EditOrganisationPerson } from "../../Modules/Organisations/PeopleAndTraining/Person/EditPerson/EditOrganisationPerson";
import { BBBEEScorecardAtom } from "../../State/BBBEEScorecard.Atom";
import { LAITrainingLandingPage } from "../../Modules/Organisations/PeopleAndTraining/Training/LAITrainingLandingPage";
import { OrganisationTraining } from "../../Modules/Organisations/PeopleAndTraining/Training/OrganisationTraining";
import { UserRolesPage } from "../../Modules/Base/UserManagement/UserRoles/UserRolesPage";
import { InternalTrainingBaseForm } from "../../Modules/Organisations/PeopleAndTraining/Training/Internal/InternalTrainingBaseForm";
import { ExternalTrainingBaseForm } from "../../Modules/Organisations/PeopleAndTraining/Training/External/ExternalTrainingBaseForm";
import { PrivateRoute } from "./PrivateRoutes";
import { AdvisoryRoutes } from "./AdvisoryRoutes";
import config from "../../config";
import { ClientRegistrations } from "../../Modules/Advisory/ClientRegistrations/ClientRegistrations";
import { ClientRegistrationAtom } from "../../State/Advisory/ClientRegistration.Atom";
import { ScorecardLicenseExpiryService } from "../Api/ScorecardLicenseExpiry/ScorecardLicenseExpiryService";
import { ScorecardLicenseExpiryModalResult, ScorecardLicenseRenewalResult } from "../Model/Dto/ScorecardLicenseExpiry/ScorecardLicenseExpiry";
import { ScorecardLicenseExpiryModal } from "../../Modules/BEEScorecards/ScorecardLicenses/ScorecardLicenseExpiryModal/ScorecardLicenseExpiryModal";
import { ScorecardLicenseRenewalModal } from "../../Modules/BEEScorecards/ScorecardLicenses/ScorecardLicenseRenewalModal/ScorecardLicenseRenewalModal";
import { BEEScorecardService } from "../Api/BEEScorecard/BEEScorecard";
import { ModuleType } from "../Model/Enum/BEE123Enums";
import { isExpired } from "../../Helpers/scorecardHelper";
import { toast } from "react-toastify";
import { coreTokenAtom, tokenAtom } from "../../State/Token.Atom";
import { EEScorecardService } from "../Api/EmploymentEquity/Scorecard/EEScorecardService";
import { useBEEElementRoutes } from "../../Hooks/useBEEElementRoutes";

export function RouterBase() {
    const mainPanel = React.createRef();
    const page = useRecoilValue(PageAtom);
    const { routes: dynamicBEERoutes, loading: beeRoutesLoading } = useBEEElementRoutes();
    const scorecard = useRecoilValue(ScorecardAtom);
    const WSPScorecard = useRecoilValue(WSPScorecardAtom);
    const bbbeeScorecard = useRecoilValue(BBBEEScorecardAtom);
    const organisation = useRecoilValue(OrganisationAtom);
    const verificationCompany = useRecoilValue(VerificationCompanyAtom);
    const location = useLocation();
    const dontRenderOnPaths = ['login', 'ForgotUsername', 'ForgotPassword', 'VerificationAgencyApplication', 'VerificationAgencyFeedback'];
    const show = !dontRenderOnPaths.some(el => location.pathname.includes(el));
    const userRoles = useRecoilValue(userRolesState);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isApplicationSelected, setIsApplicationSelected] = React.useState(false);
    const [isOrganisationSelected, setIsOrganisationSelected] = React.useState(false);
    const currentUser = useRecoilValue(UserAtom);
    const userRegistrationId = useRecoilValue(userRegistrationIdState);
    const clientRegistration = useRecoilValue(ClientRegistrationAtom);

    const [scorecardLicenseExpiryData, setScorecardLicenseExpiryData] = useState<ScorecardLicenseExpiryModalResult>();    
    const [showExpiryModal, setShowExpiryModal] = useState(false);
    const [scorecardLicenseRenewalData, setScorecardLicenseRenewalData] = useState<ScorecardLicenseRenewalResult>();
    const [showRenewalModal, setShowRenewalModal] = useState(false);

    const [hasActiveBEELicenses, setHasActiveBEELicenses] = useState(false);
    const [hasActiveEELicenses, setHasActiveEELicenses] = useState(false);

    const token = useRecoilValue(tokenAtom);
    const coreToken = useRecoilValue(coreTokenAtom);
    const history = useHistory();

    const fetchScorecardLicenseExpiryData = async () => {
        try {
            const expiryResult = await ScorecardLicenseExpiryService.showExpiryModal();
            setScorecardLicenseExpiryData(expiryResult.data);
            setShowExpiryModal(expiryResult.data.showModal);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchScorecardLicenseRenewalData = async () => {
        try {
            const renewalResult = await ScorecardLicenseExpiryService.showRenewalModal();
            setScorecardLicenseRenewalData(renewalResult.data);
            setShowRenewalModal(renewalResult.data.showModal);
        } catch (error) {
            console.log(error);
        }
    }

    const handleExpiryModalClose = async () => {
        if (scorecardLicenseExpiryData) {        
            try {
                await ScorecardLicenseExpiryService.acknowledgeExpiryNotification(scorecardLicenseExpiryData.scorecardExpiryNotificationId);
            } catch (error) {
                console.log(error);
            }
        }       
        
        setShowExpiryModal(false);
    }
    
    const handleRenewalModalClose = async () => {
        if (scorecardLicenseRenewalData) {        
            try {
                await ScorecardLicenseExpiryService.acknowledgeExpiryNotification(scorecardLicenseRenewalData.scorecardExpiryNotificationId);
            } catch (error) {
                console.log(error);
            }
        }       
        
        setShowRenewalModal(false);
    }

    const fetchAccessibleModules = async () => {
        try {
            const accessibleModulesResult = await BEEScorecardService.GetAccessibleModules();
            setHasActiveBEELicenses(accessibleModulesResult.data.includes(ModuleType.BEE_Module));
            setHasActiveEELicenses(accessibleModulesResult.data.includes(ModuleType.Employment_Equity_Module));
        } catch (error) {
            console.log(error);
        }
    }

      useEffect(() => {
        if (!token || !coreToken) return;
    
        const match = location.pathname.match(/\/ee\/scorecard\/([^/]+)/i);
        if (!match) return;
    
        const scorecardId = match[1].toLowerCase();
    
        ( async () => {
          try {
            const result = await EEScorecardService.GetEEGeneralInfo(scorecardId);
    
            if (result.data.LicenseExpiryDate && isExpired(result.data.LicenseExpiryDate)) {
              toast.error("The scorecard license has expired. Please renew your license before you can edit", { toastId: "expired-license" });
              history.replace("/ee/base");
            }
          } catch (error) {
            console.error('Error checking scorecard license:', error);
          }
        })();
      }, [location.pathname, history, token, coreToken]);

    useEffect(() => {
        fetchScorecardLicenseExpiryData();
        fetchScorecardLicenseRenewalData();
        fetchAccessibleModules();

        if (verificationCompany.applicationId !== -1) {
            setIsApplicationSelected(true);
        } else {
            setIsApplicationSelected(false);
        }

        if (organisation.OrganisationName) {
            setIsOrganisationSelected(true);
        } else {
            setIsOrganisationSelected(false);
        }
    }, [verificationCompany, organisation]);
    

    const renderRoute = (prop: any, key?: number) => {
        if (prop.isExternal) {
            // Route to external URL
            return (
                <ExternalRedirect
                    exact={true}
                    path={prop.layout + prop.path}
                    link={prop.Component}
                    key={key}
                />
            );
        }
        return (
            <Route
                path={prop.layout + prop.path}
                key={key}
                render={(routeProps) => (
                    <prop.Component {...routeProps} {...prop.componentProps} />
                )}
            />
        );
    }

    const getRoutes = (routes: any, parentRoute?: any) => {
        let renderedRoutes = routes.map((prop: any, key: number) => {
            if (prop.userRoleIncludes != null) {
                if (!userRoles.some((r) => prop.userRoleIncludes.includes(r))) {
                    return null;
                }
            }
            if (prop.userRoleExcludes != null) {
                if (userRoles.some((r) => prop.userRoleExcludes?.includes(r))) {
                    return null;
                }
            }
            if (prop.collapse) {
                return getRoutes(prop.views);
            }
            if (prop.hasChildren === true && prop.collapse === false) {
                return getRoutes(prop.views, prop);
            }
            return renderRoute(prop, key);
        });

        if (parentRoute) {
            const parent = renderRoute(parentRoute);
            renderedRoutes.push(parent);
        }
        return renderedRoutes;
    };

    const getAdvisoryRoutes = () => {
        if (!isNullOrEmpty(userRegistrationId) && config.advisory_registration_id.toLocaleLowerCase() === userRegistrationId.toLocaleLowerCase()){
            return BEEHubRoutes(userRegistrationId);
        }else {
            return null
        }
    }
    const getBBBEERoutesForRendering = () => {
        if (!isNullOrEmpty(bbbeeScorecard.scorecardId)) {
            const nonDataPageRoutes = BBBEEScorecardRoutes.filter(r =>
                r.name === 'Verification Process' ||
                r.name === 'Scorecard Outcome' ||
                r.name === 'Import Management'
            );

            if (userRoles.includes(AuditRole) || userRoles.includes(ClientRole)) {
                return nonDataPageRoutes;
            }

            if (!beeRoutesLoading && dynamicBEERoutes.length > 0) {
                return dynamicBEERoutes;
            }
        }
        return BBBEEScorecardRoutes;
    };

    const getDynamicRoutes = () => {
        if (location.pathname.includes('/createscorecard') || location.pathname.includes('/createconsolidations')) {
            return [];
        }

        if (!isNullOrEmpty(scorecard.scorecardId) && !userRoles.includes(AuditRole)) {
            return EEScorecardRoutes;
        }

        if (verificationCompany.vaClientId !== -1 && userRoles.includes(AuditRole)) {
            return VerificationCompanyRoutes(isApplicationSelected);
        }

        if (!isNullOrEmpty(WSPScorecard.wspScorecardId) && !userRoles.includes(AuditRole)) {
            return OFOCodesCategorisationRoute(currentUser.hasWSPScorecards === true);
        }

        if (!isNullOrEmpty(bbbeeScorecard.scorecardId)) {
            const nonDataPageRoutes = BBBEEScorecardRoutes.filter(r =>
                r.name === 'Verification Process' ||
                r.name === 'Scorecard Outcome' ||
                r.name === 'Import Management'
            );

            if (userRoles.includes(AuditRole) || userRoles.includes(ClientRole)) {
                return nonDataPageRoutes;
            }

            if (beeRoutesLoading) {
                return [];
            }

            if (dynamicBEERoutes.length > 0) {
                return dynamicBEERoutes;
            }
            return BBBEEScorecardRoutes;
        }

        if (!isNullOrEmpty(clientRegistration.clientRegistrationId)) {
            return BEE123RegistrationRoutes;
        }

        if (organisation.OrganisationId !== -1 && !userRoles.includes(AuditRole) && !userRoles.includes(ClientRole)) {
            return OrganisationRoute(isOrganisationSelected, currentUser.hasWSPScorecards, organisation.ShowPayrollIntegrationMenuItems ?? false);
        }

        return [];
    }

    const getUserInitials = (fullName: string) => {
        const names = fullName.split(' ');
        if (names.length === 1) {
            return names[0].substring(0, 2).toUpperCase();
        } else {
            return names.map(name => name.substring(0, 1).toUpperCase()).join('');
        }
    };

    const handleMiniClick = () => {
        document.body.classList.toggle("sidebar-mini");
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };
    if (show) {
        return (
            <DashboardLayout>
                <div className="wrapper">
                    <Sidebar
                        activeColor={"danger"}
                        AccountRoutes={AccountRoute}
                        ConstantRoutes={ConstantRoutes(currentUser.hasWSPScorecards === true, hasActiveBEELicenses, hasActiveEELicenses)}
                        ProtectedRoutes={userRoles.includes(AuditRole) ? VerificationRoutes : ClientRoutes(currentUser.hasWSPScorecards === true, currentUser.enablePayrollIntegration)}
                        AdvisoryRoutes={getAdvisoryRoutes()}
                        DynamicRoutes={getDynamicRoutes()}
                        RegistrationRoutes={!isNullOrEmpty(clientRegistration.clientRegistrationId) && !isNullOrEmpty(scorecard.scorecardId) ? BEE123RegistrationRoutes : []}
                        LoggedInUser={isSidebarCollapsed && currentUser.isClient ? getUserInitials(currentUser.contactName) : currentUser.contactName ?? "N/A"}
                        isSidebarCollapsed={isSidebarCollapsed}
                    />

                    <div className="main-panel" ref={mainPanel as React.RefObject<HTMLDivElement>} style={{
                        display:'flex',
                        flexDirection: 'column',
                        minHeight:'100vh'
                    }}>
                        <TopNavbar handleMiniClick={handleMiniClick} pageTitle={page.pageTitle} />
                        <div className="content" style={{
                            flexGrow: 1
                        }}>
                            <Switch>
                                <PrivateRoute roles={[PlatformPeopleViewRole, PlatformPeopleEditRole, UserAdminRole]} path={"/organisation/people/person"} exact component={CreateOrganisationPerson} />
                                <PrivateRoute roles={[PlatformPeopleEditRole, PlatformPeopleViewRole, UserAdminRole]} path={"/organisation/people/person/edit/:platformPeopleId"} component={EditOrganisationPerson} />
                                <AdvisoryRoutes path={"/advisory/clientRegistrations"} exact component={ClientRegistrations} />

                                <Route path={"/organisation/training"} exact component={OrganisationTraining} />
                                <Route path={"/organisation/training/Internal/form"} component={InternalTrainingBaseForm} />
                                <Route path={"/organisation/training/LAI/form"} component={LAITrainingLandingPage} />
                                <Route path={"/organisation/training/External/form"} component={ExternalTrainingBaseForm} />
                                {getRoutes(AccountRoute)}
                                {getRoutes(ConstantRoutes(currentUser.hasWSPScorecards === true, hasActiveBEELicenses, hasActiveEELicenses))}
                                {userRoles.includes(AuditRole) ? getRoutes(VerificationRoutes) : getRoutes(ClientRoutes(currentUser.hasWSPScorecards === true, currentUser.enablePayrollIntegration))}
                                {userRoles.includes(AuditRole) ? getRoutes(VerificationCompanyRoutes(isApplicationSelected)) : getRoutes(EEScorecardRoutes)}
                                {getRoutes(AllNotesRoute)}
                                {getRoutes(OFOCodesCategorisationRoute(currentUser.hasWSPScorecards === true))}
                                {getRoutes(OrganisationRoute(isOrganisationSelected, currentUser.hasWSPScorecards === true, organisation.ShowPayrollIntegrationMenuItems ?? false))}
                                {getRoutes(getBBBEERoutesForRendering())}
                                {getRoutes(BEE123RegistrationRoutes)}
                                <Route path={"/userRoles/:id"} component={UserRolesPage} />
                                <Route path={'/Import'} component={IndividualImport} />
                                <Route path={'/ImportSalary'} component={IndividualSalariesImport} />
                                {!beeRoutesLoading && <Redirect from="/" to="/home" />}
                            </Switch>
                        </div>
                        <Footer buildId={environment.VERSION} />
                    </div>
                </div>

                {showRenewalModal && scorecardLicenseRenewalData && (
                    <ScorecardLicenseRenewalModal
                        username={currentUser.contactName}
                        renewalResult={scorecardLicenseRenewalData}
                        open={showRenewalModal}
                        close={handleRenewalModalClose}
                    />
                )}

                {showExpiryModal && scorecardLicenseExpiryData && (
                    <ScorecardLicenseExpiryModal
                        username={currentUser.contactName}
                        licenseResult={scorecardLicenseExpiryData}
                        open={showExpiryModal}
                        close={handleExpiryModalClose}
                    />
                )}

            </DashboardLayout>
        );
    } else {
        return (<></>)
    }
}
